var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconPause = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_1238",
  "data-name": "Group 1238",
  transform: "translate(-1056 -318)"
}, /*#__PURE__*/React.createElement("path", {
  id: "pause_circle_outline-24px",
  d: "M8,12.5a.752.752,0,0,0,.75-.75V7.25a.75.75,0,0,0-1.5,0v4.5A.752.752,0,0,0,8,12.5ZM9.5,2A7.5,7.5,0,1,0,17,9.5,7.5,7.5,0,0,0,9.5,2Zm0,13.5a6,6,0,1,1,6-6A6.008,6.008,0,0,1,9.5,15.5Zm1.5-3a.752.752,0,0,0,.75-.75V7.25a.75.75,0,0,0-1.5,0v4.5A.752.752,0,0,0,11,12.5Z",
  transform: "translate(1054 316)",
  fill: "#173a6d"
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPause, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_pause.655692cb.svg";
export { ForwardRef as ReactComponent };